<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <b-row>
      <b-col cols="2">
      </b-col>
      <b-col cols="8">
        <div class="barra">
          <b-row>
            <div class="col-sm-6 col-md-6 d-flex text-left">
              <b-form-input
                  class="ml-3 input-filter"
                  placeholder="Búsqueda por ID o nombre del paciente"
                  v-model="filtro.nombrePaciente"
              ></b-form-input>
            </div>

            <div class="col-sm-10 col-md-5 text-right">
              <b-dropdown
                  variant="ligth"
                  id="dropdown-fechai"
                  :text="texFechaInicio"
                  class="btn-filter"
              >
                <b-calendar
                    class="m-2"
                    v-model="filtro.fechaInicio"
                    :max="new Date()"
                    locale="en-US"
                ></b-calendar>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button
                    class="text-right"
                    @click="limpiar(null, 'fechaInicio', null)"
                >
                  <em class="fa fa-close"></em> Limpiar
                </b-dropdown-item-button>
              </b-dropdown>
              <b-dropdown
                  variant="ligth"
                  id="dropdown-fechaf"
                  :text="texFechaFin"
                  class="btn-filter"
              >
                <b-calendar
                    class="m-2"
                    v-model="filtro.fechaFin"
                    :min="
                        filtro.fechaInicio === null
                          ? new Date()
                          : filtro.fechaInicio
                      "
                    :max="new Date()"
                    locale="en-US"
                ></b-calendar>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button
                    class="text-right"
                    @click="limpiar(null, 'fechaFin', null)"
                >
                  <em class="fa fa-close"></em> Limpiar
                </b-dropdown-item-button>
              </b-dropdown>
            </div>
            <div class="col-md-1  col-sm-12 text-right">
              <b-button
                  variant="info"
                  :disabled="loader"
                  @click="obtenerDatos()"
              >
                  <span v-if="!loader"
                  ><font-awesome-icon icon="search"
                  /></span>
                <span v-else><b-spinner small></b-spinner></span>
              </b-button>
            </div>
          </b-row>
        </div>
      </b-col>
      <b-col cols="2">
      </b-col>
    </b-row>

    <!-- TABS -->

    <div class="mt-3">
      <b-tabs v-model="tabIndex">
        <b-tab title="PENDIENTES" active>
        </b-tab>

        <b-tab title="COMPLETADOS">
        </b-tab>

        <b-tab title="EXPIRADOS">
        </b-tab>

        <div class="overflow-auto">
          <b-table
              :items="registros"
              :fields="columnas"
              show-empty
              responsive
              class="contenedorTablaSinColor"
          >
            <template #cell(color)="row">
              <b-icon font-scale="2" icon="circle-fill" :style="'color: '+row.item.color"
                      ></b-icon>
            </template>
            <template v-slot:cell(fechaAltaEnListaEspera)="row">
              {{ row.item.fechaAltaEnListaEspera | formatoFechaHora }}
            </template>
            <template v-slot:cell(fechaInicioCitaSolicitada)="row">
              {{ row.item.fechaInicioCitaSolicitada | formatoFecha }}
            </template>
            <template v-slot:cell(fechaFinCitaSolicitada)="row">
              {{ row.item.fechaFinCitaSolicitada | formatoFecha }}
            </template>
            <template v-slot:cell(horaInicioCitaSolicitada)="row">
              {{ row.item.horaInicioCitaSolicitada | formatoHoraDeEntero }}
            </template>
            <template v-slot:cell(horaFinCitaSolicitada)="row">
              {{ row.item.horaFinCitaSolicitada | formatoHoraDeEntero }}
            </template>
            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button
                    v-if="tabIndex===0 && row.item.idEstatusListaEspera === 1"
                    title="Contactar al usuario"
                    size="sm"
                    variant="outline-warning"
                    @click="modificar(row.item)"
                ><em class="fa fa-pencil"></em
                ></b-button>
                <b-button
                    v-if="tabIndex===0 && row.item.idEstatusListaEspera === 1"
                    title="Buscar horarios en agenda"
                    size="sm"
                    variant="success"
                    style="background-color: var(--color-verde);color:white;"
                    @click="preBuscarAgenda(row.item)"
                >
                  <font-awesome-icon icon="search"/>
                </b-button>
                <b-button
                    size="sm" variant="info" @click="abrirModalDetalle(row.item)"><em class="fa fa-eye"></em>
                </b-button>
              </b-button-group>
            </template>
            <template #empty="scope">
              <div align="center" v-if="loader">
                <b-spinner variant="primary" label="Spinning"></b-spinner>
              </div>
              <div v-if="!loader">
                <b-alert show variant="warning">No hay datos</b-alert>
              </div>
            </template>
          </b-table>

          <b-pagination
              v-if="registros !== undefined"
              align="center"
              v-model="paginaActual"
              :total-rows="totalRegistros"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
          ></b-pagination>
        </div>

      </b-tabs>
    </div>

    <b-modal v-model="modalDatosComplementarios"
             title="Contacto a paciente"
             size="lg"
             scrollable
    >
      <p>Por favor llene los datos faltantes para considerar esta cita en la lista de espera</p>
      <div v-if="itemEditar != null">
        <div style="font-weight: 600; font-size: 15px;">
          <p>Paciente: {{ itemEditar.nombrePaciente }}</p>
          <p>Doctor asignado en cita perdida: {{ itemEditar.nombreDoctor }}</p>
          <p>Especialidad de cita perdida: {{ itemEditar.nombreEspecialidad }}</p>
          <p>Tratamiento de cita perdida: {{ itemEditar.nombreTratamiento }}</p>
        </div>
        <b-row class="mt-4">
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha inicio de cita solicitada</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaInicioCitaSoli"/>
                <b-form-datepicker
                    id="fechacita-datepicker"
                    labelNoDateSelected="Fecha inicio de cita solicitada"
                    v-model="itemEditar.fechaInicioCitaSolicitada"
                    range
                    class="mb-2"
                    :min="fechaMinima"
                    in
                    no-flip
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Fecha fin de cita solicitada</label>
              <validacion/>
              <b-form-group>
                <b-spinner small v-if="loadingFechaFinCitaSoli"/>
                <b-form-datepicker
                    id="fechacitafin-datepicker"
                    labelNoDateSelected="Fecha fin de cita Solicitada"
                    v-model="itemEditar.fechaFinCitaSolicitada"
                    range
                    class="mb-2"
                    :min="fechaFinMinima"
                    in
                    no-flip
                ></b-form-datepicker>
                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-form-group align="left">
              <label>Días de exclusión:</label>
              <v-select
                  style="width: 100%"
                  name="dia"
                  placeholder="--Seleccionar--"
                  label="descripcion"
                  multiple
                  :options="listaDias"
                  :reduce="(variable) => variable.id"
                  v-model="itemEditar.diasExclusion"
              ><span slot="no-options">No hay dias disponibles</span>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Hora inicio</label>
              <validacion/>
              <b-form-group>
                <vue-timepicker
                    id="idHoraInicio"
                    v-model="itemEditar.horaInicioCitaSolicitadaN"
                    hide-disabled-items
                    format="HH:mm"
                    :minute-interval="15"
                    :hour-range="rangoHoraForm"
                    hide-clear-button
                ></vue-timepicker>

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col>
            <validation-provider
                :rules="{ required: true }"
                v-slot="errors"
            >
              <label>Hora fin</label>
              <validacion/>
              <b-form-group>
                <vue-timepicker
                    id="idHoraFin"
                    v-model="itemEditar.horaFinCitaSolicitadaN"
                    hide-disabled-items
                    format="HH:mm"
                    :minute-interval="15"
                    :hour-range="rangoHoraForm"
                    hide-clear-button
                ></vue-timepicker>

                <validacion
                    :texto="errors.errors[0] ? errors.errors[0] : ' '"
                />
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" v-if="rangoHoraClinica !== undefined">
            Horario(s) Clinica:
            <b-badge v-for="hc in rangoHoraClinica" v-bind:key="hc">{{
                hc
              }}
            </b-badge>
          </b-col>
          <b-col cols="12" v-else>
            <validacion
                texto="Tu clinica no cuenta con ningún horario"
            />
          </b-col>

        </b-row>

        <b-row class="mt-4">
          <b-col><label>Comentarios:</label>
            <b-form-textarea
                id="textarea"
                v-model="itemEditar.comentario"
                placeholder="Comentarios"
                rows="3"
                max-rows="6"
            ></b-form-textarea>
          </b-col>
        </b-row>
        <b-row>
        </b-row>

      </div>
      <template v-slot:modal-footer>
        <b-button variant="outline-info" @click="actualizarRegistroLista()"
        >Guardar
        </b-button
        >
        <b-button
            variant="outline-secondary"
            @click="modalDatosComplementarios = false"
        >Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="modalDetalleLista"
             title="Información"
             size="lg"
             scrollable>
      <h5 class="tituloDetalle">Detalles del registro</h5>
      <b-table stacked :items="detalle">
        <template v-slot:cell(Semaforo_de_urgencia)="row">
          <div :style="semaforoDeUrgencia">
            {{ row.item.Semaforo_de_urgencia }}
          </div>
        </template>
        <template v-slot:cell(fechaAltaEnListaEspera)="row">
          {{ row.item.fechaAltaEnListaEspera | formatoFechaCorta }}
        </template>
        <template v-slot:cell(fechaInicioCitaSolicitada)="row">
          {{ row.item.fechaInicioCitaSolicitada | formatoFechaCorta }}
        </template>
        <template v-slot:cell(fechaFinCitaSolicitada)="row">
          {{ row.item.fechaFinCitaSolicitada | formatoFechaCorta }}
        </template>
      </b-table>
      <template #modal-footer>
        <div>
          <b-button size="md" variant="outline-danger" @click="cerrarModalDetalle()">Cerrar</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-model="showMostrarPreBuscarCita"
             size="lg"
             hide-footer>

      <template #modal-title>
        <em class="cita_svg color-icono-modal" style="height: 20px;"></em> Bandeja de lista de espera
      </template>

      <b-container style="width: 80%">
        Selecciona la duración de la cita, antes de realizar la búsqueda de espacios disponibles

        <b-row class="mt-3">
          <b-col cols="6">
            <label>Duración hrs</label>
             <b-form-select v-model="datosDetalle.horasBusquedaDisp" class="mb-3">
               <b-form-select-option-group label="HH">
                <b-form-select-option :value="0">0</b-form-select-option>
                 <b-form-select-option :value="1">1</b-form-select-option>
                 <b-form-select-option :value="2">2</b-form-select-option>
               </b-form-select-option-group>
              </b-form-select>
          </b-col>
          <b-col cols="6">
            <label>Duración minutos</label>
            <b-form-select v-model="datosDetalle.minBusquedaDisp" class="mb-3">
              <b-form-select-option-group label="MM">
                <b-form-select-option :value="0">0</b-form-select-option>
                <b-form-select-option :value="15">15</b-form-select-option>
                <b-form-select-option :value="30">30</b-form-select-option>
                <b-form-select-option :value="45">45</b-form-select-option>
              </b-form-select-option-group>
            </b-form-select>
          </b-col>
        </b-row>

        <div style="text-align: center">
          <b-button size="md"  class="button-dentalia-1" @click="buscarAgenda()">Buscar</b-button>
        </div>
      </b-container>
    </b-modal>

    <b-modal v-model="showAgendarListaEspera"
             size="xl"
             hide-footer
    >
      <template #modal-title>
        <em class="cita_svg color-icono-modal" style="height: 20px;"></em> Bandeja de lista de espera
      </template>

      <div style="text-align: center" v-if="cargandoHorariosDisponibles">
        <b-skeleton width="85%" height="90%"/>
        <b-skeleton width="85%" height="90%"/>
        <b-skeleton width="85%" height="90%"/>
      </div>
      <b-row v-else>
        <b-col cols="3" v-if="!showAgendarNuevaCita">
          <CardPacienteAgenda
              :datosDetalle="detalle[0]"
              :origen="3"
          ></CardPacienteAgenda>
        </b-col>
        <b-col :cols="showAgendarNuevaCita ? 12 :9">
          <nuevaCita v-if="showAgendarNuevaCita"
              :datosPreCita="datosFormulario"
              :idClinica="idClinica"
              :vistaModal="true"
              :empleadosEsp="empleadosEsp"
              @cerrarModal="()=>{showAgendarNuevaCita = false;}"
              @guardarNuevaCitaV2="guardadoCitaExitoso"/>

          <div v-else>
            <div v-if="lstHorariosDisponibles != null">
              <div style="margin-bottom: 0px;" class="mb-2">
                <strong style="color:#0069aa"> Horarios disponibles encontrados </strong>
              </div>
              <div style="height: 450px; overflow: auto;">
                <div class="borde-azul-simple pb-0 mb-2" v-for="horario in lstHorariosDisponibles" :key="horario.num">
                  <b-table-simple style="margin-bottom: 0px;">
                    <b-tr>
                      <b-th style="text-align: center; font-weight: bolder;"><span>Fecha</span></b-th>
                      <b-th style="text-align: center; font-weight: bolder;"><span>Sillón</span></b-th>
                      <b-th style="text-align: center; font-weight: bolder;"><span>Horario</span></b-th>
                      <b-th style="text-align: center; font-weight: bolder;"><span>Acciones</span></b-th>
                    </b-tr>
                    <b-tr>
                      <b-th style="text-align: center; font-weight: normal;">{{ horario.fechaCita | formatoFecha }}
                      </b-th>
                      <b-th style="text-align: center; font-weight: normal;">{{ horario.sillon }}</b-th>
                      <b-th style="text-align: center; font-weight: normal;">
                        {{ horario.horaInicio | formatoHoraDeEntero }} - {{ horario.horaTermina | formatoHoraDeEntero }}
                      </b-th>
                      <b-th style="text-align: center; font-weight: normal;">
                        <b-button class="button-dentalia-svg-1" variant="primary"
                                  @click="agendarHorarioDisponible(horario)"
                                  title="Agendar">
                          <em class="cita_svg icon-dentalia-svg-1"></em>
                        </b-button>
                      </b-th>
                    </b-tr>
                  </b-table-simple>
                </div>
              </div>
            </div>
            <b-row style="color:#0069aa; max-width: 50%; height: 400px; margin: auto;" v-else>
              <div style="  margin: auto;">
                <b-col cols="12" style="text-align: center;">
                  <b-img
                      :src="require('../../assets/agenda/no-result.png')"
                      width="120"
                  ></b-img>
                </b-col>
                <b-col cols="12" class="mt3" style="text-align: center;">
                  No se encontraron horarios disponibles. Intenta buscar otras opciones con el calendario de agendar
                  cita.
                </b-col>
              </div>
            </b-row>

            <div class="mt-3" style="text-align: center">
              <b-button class="button-dentalia-1" v-if="lstHorariosDisponibles == null" @click="agregarAgendaManual">
                Buscar
              </b-button>
              <b-button class="ml-5 button-dentalia-2" @click="showAgendarListaEspera = false">Cerrar</b-button>
            </div>
          </div>

        </b-col>
      </b-row>

    </b-modal>


  </div>
</template>

<script>

import CardPacienteAgenda from "@/components/NuevaAgenda/CardPacienteAgenda";
import nuevaCita from "@/components/NuevaAgenda/nuevaCita/nuevaCita";
import {DatosTratamientoCita} from "@/components/NuevaAgenda/nuevaCita/DatosTratamientoCita";

export default {
  name: "ListaEspera",
  components: {
    CardPacienteAgenda,
    nuevaCita
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      cargandoHorariosDisponibles: true,
      lstHorariosDisponibles: null,
      tabIndex: 0,
      registrosPorPagina: 20,
      totalRegistros: null,
      paginaActual: 1,
      itemEditar: {
        fechaCita: null,
        horaInicioCitaSolicitadaN: null,
        horaFinCitaSolicitadaN: null,
      },
      loadingFechaFinCitaSoli: false,
      horariosClinica: [],
      loadingFechaInicioCitaSoli: false,
      listaDias: [],
      modalDatosComplementarios: false,
      modalDetalleLista: false,
      datosComplementarios: {
        nombrePacienteBusqueda: null,
        idPaciente: null,
        idDoctor: null,
        idConfianza: null,
        sillon: 1,
        fechaCita: new Date(),
        horaInicio: {
          HH: "08",
          mm: "00",
        },
        horaFin: {
          HH: "08",
          mm: "00",
        },
        comentario: null,
        idCompania: 1,
        idClinica: null,
        idCanalOrigen: 1,
        idEspecialidad: null,
        idTratamiento: null,
        idTagMotivoCita: null,
        diasExclusion: null,
      },
      detalle: [],
      datosDetalle: [],
      tipoBusqueda: 1,
      loader: false,
      todas: true,
      filtro: {
        nombre: null,
        idPaciente: null,
        idsClinica: [],
        fechaInicio: null,
        fechaFin: null,
        idEstatus: null,
        idEstatusSolicitud: null
      },
      semaforoDeUrgencia: null,
      semaforo: {
        urgente: 0,
        espera: 0
      },
      columnas: [
        {key: "color", label: "Estatus", sortable: true},
        {key: "fechaAltaEnListaEspera", label: "Fecha alta", sortable: true},
        {key: "nombreClinica", label: "Clínica", sortable: true},
        {key: "idPaciente", label: "Id paciente", sortable: true},
        {key: "nombrePaciente", label: "Nombre paciente", sortable: true},
        {key: "telefono", label: "Telefono", sortable: true},
        {key: "correo", label: "Correo", sortable: true},
        {key: "motivoEspera", label: "Motivo", sortable: true},
        {key: "fechaInicioCitaSolicitada", label: "Fecha inicio cita solicitada", sortable: true},
        {key: "fechaFinCitaSolicitada", label: "Fecha fin cita solicitada", sortable: true},
        {key: "horaInicioCitaSolicitada", label: "Hora inicio cita solicitada", sortable: true},
        {key: "horaFinCitaSolicitada", label: "Hora fin cita solicitada", sortable: true},
        "Acciones"
      ],
      listaClinicas: [],
      //Como ejemplo de como va a quedar
      registros: [],

      showMostrarPreBuscarCita: false,
      showAgendarListaEspera: false,
      showAgendarNuevaCita: false,
      datosFormulario: null,
      guardando: false
    }
  },
  props: {
    idClinica: {
      type: Number,
      default: null
    },
    empleadosEsp: Array
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    if (this.idClinica !== null) {
      this.filtro.idsClinica = [this.idClinica];
    }

    this.obtenerDatos();
    this.initDatosCitaNueva();
    this.buscarHorariosClinica();
    this.llenarClinicas();
    this.obtenerDias();
  },
  methods: {
    async actualizarRegistroLista() {
      if (!this.rangoHoraFormEsValidoEditar(this.itemEditar)) {
        this.$swal.fire({
          icon: "error",
          title: "Selecciona un horario válido para poder continuar",
        });
        return;
      }

      let datos = this.itemEditar;
      datos.horaInicio = datos.horaInicioCitaSolicitadaN.HH + datos.horaInicioCitaSolicitadaN.mm;
      datos.horafin = datos.horaFinCitaSolicitadaN.HH + datos.horaFinCitaSolicitadaN.mm;
      datos.fechaInicio = this.$moment(datos.fechaInicioCitaSolicitada).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      datos.fechaFin = this.$moment(datos.fechaFinCitaSolicitada).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      if (datos.diasExclusion === undefined || datos.diasExclusion === null) {
        datos.diasExclusion = [];
      }

      this.$http
          .post(
              this.$api +
              "agendaclinica/listaEspera/guardar", datos
          )
          .then(() => {
            this.$swal.fire({
              icon: "success",
              title: "Aviso",
              text: "Se agregó a la lista de espera de manera éxitosa",
            });
            this.modalDatosComplementarios = false;
            this.obtenerDatos();
          })
          .catch((error) => {
            console.error("Error", error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Ocurrió un error al enviar a la lista de espera",
            });
          });
    },
    initDatosCitaNueva() {
      this.datosComplementarios = {
        nombrePacienteBusqueda: null,
        idPaciente: null,
        idDoctor: null,
        idConfianza: null,
        sillon: 1,
        fechaCita: new Date(),
        horaInicio: {
          HH: "08",
          mm: "00",
        },
        horaFin: {
          HH: "08",
          mm: "00",
        },
        comentario: null,
        idCompania: 1,
        idClinica: null,
        idCanalOrigen: 1,
        idEspecialidad: null,
        idTratamiento: null,
        idTagMotivoCita: null,
      };
      this.tagMotivoCita();
    },
    tagMotivoCita() {
      this.tagmotivocitaDatosArray = [];

      if (
          this.datosFormulario !== undefined &&
          this.datosFormulario !== null &&
          this.datosFormulario.idPaciente !== undefined &&
          this.datosFormulario.idPaciente !== null
      ) {
        const params = {
          idPaciente: this.datosFormulario.idPaciente
        }
        this.$http.post(this.$api + "tagmotivocita/tagmotivocita/paciente", params )
            .then((response) => {
              this.tagmotivocitaDatosArray = response.data.data;
              this.tagmotivocitaDatosArrayFiltro = this.tagmotivocitaDatosArray;
              this.listaDoctores = [];
              if (this.datosFormulario.citaEmbajador) {
                this.llenarDoctoresEmbajadorClinica(
                    this.datosBusqueda.clinica.clinicaID
                );
              } else {
                this.llenarDoctoresEspecialistasClinica(
                    this.datosBusqueda.clinica.clinicaID
                );
              }
            });
      }
    },
    buscarHorariosClinica() {
      const idClinica = this.idClinica;
      let hoy = new Date();
      this.loadingHorariosClinica = true;

      const clinicaID = idClinica;

      let fechaInicio = null;
      try {
        fechaInicio = this.$moment(hoy)
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      } catch (e) {
        fechaInicio = this.datosComplementarios.fechaCita
                .utc()
                .format("YYYY-MM-DD[T]HH:mm[:00Z]");
      }

      const parametros = {
        idClinica: clinicaID,
        fechaInicio: fechaInicio
      }
      this.$http
          .post(
              this.$api +
              "agenda/obtenerHorariosClinicaParaAgenda", parametros
          )
          .then((response) => {
            if (response.status === 200 && response.data.data !== undefined) {
              this.procesarHorariosClinica(response)
                  .then(() => {
                    if (this.$refs.calDentalia !== undefined) {
                      this.$refs.calDentalia.calcularSemana(
                          this.datosComplementarios.fechaInicio,
                          this.eventos,
                          this.horariosDoctor,
                          this.getNumeroSillonesClinica
                      );
                    }
                    this.loadingHorariosClinica = false;
                  })
                  .catch((e) => {
                    this.loadingHorariosClinica = false;
                    console.error(e);
                  });
            }
          })
          .catch((error) => {
            console.error("No hay datos" + error);
            this.loadingHorariosClinica = false;
          });
    },
    async procesarHorariosClinica(response) {
      this.horariosClinica = [];
      if (response.data.data !== undefined && response.data.data !== null) {
        response.data.data.forEach((v) => {
          v.horaInicio = v.horaInicio.toString();

          if (v.horaInicio.length < 4) {
            v.horaInicio = "0" + v.horaInicio;
          }

          v.horaFin = v.horaFin.toString();
          if (v.horaFin.length < 4) {
            v.horaFin = "0" + v.horaFin;
          }

          const fechaEvento = this.$moment(v.fecha).utc().format("YYYY/MM/DD");
          const pos = fechaEvento + "-" + v.sillon;

          const horaIn = v.horaInicio.substr(0, 2);
          const horaFn = v.horaFin.substr(0, 2);
          const minIn = v.horaInicio.substr(2, 3);
          const minFn = v.horaFin.substr(2, 3);

          if (this.horariosClinica[pos] === undefined) {
            this.horariosClinica[pos] = {
              original: [],
              horas: [],
              horasMinutosDate: [],
            };
          }

          this.horariosClinica[pos].original.push(
              horaIn + ":" + minIn + " a " + horaFn + ":" + minFn
          );
          this.horariosClinica[pos].horas.push([
            Number(horaIn),
            Number(horaFn),
          ]);
          this.horariosClinica[pos].horasMinutosDate.push({
            horaInicio: this.$moment(
                fechaEvento + " " + horaIn + ":" + minIn + ":00"
            ),
            horaFin: this.$moment(
                fechaEvento + " " + horaFn + ":" + minFn + ":00"
            ),
          });
        });
      }
      return true;
    },
    obtenerDias() {
      this.$http
          .get(this.$api + "catalogos/obtenerDias")
          .then((response) => {
            if (response.status === 200) {
              this.listaDias = response.data.data;
            }
          })
          .catch((error) => {
            console.error(error);
          });
    },
    modificar(item) {
      this.initDatosCitaNueva();

      this.datosComplementarios = JSON.parse(JSON.stringify(item));
      this.itemEditar = JSON.parse(JSON.stringify(item));
      try {
        if (this.itemEditar.diasExclusion !== undefined && this.itemEditar.diasExclusion !== null && this.itemEditar.diasExclusion !== "") {
          this.itemEditar.diasExclusion = JSON.parse(this.itemEditar.diasExclusion);
        }
      } catch(e){console.error(e)}

      ///----

      let horaInicio = this.itemEditar.horaInicioCitaSolicitada.toString();
      if (horaInicio.length == 3) {
        horaInicio = "0" + horaInicio;
      }
      const horaInicioFinal = horaInicio.substring(0, 2);
      const minutosInicioFinal = horaInicio.substring(2, 4);

      this.itemEditar.horaInicioCitaSolicitadaN = {
        HH: horaInicioFinal,
        mm: minutosInicioFinal
      };

      ///----
      let horaFin = this.itemEditar.horaFinCitaSolicitada.toString();
      if (horaFin.length == 3) {
        horaFin = "0" + horaFin;
      }
      const horaFnFinal = horaFin.substring(0, 2);
      const minutosFnFinal = horaFin.substring(2, 4);

      this.itemEditar.horaFinCitaSolicitadaN = {
        HH: horaFnFinal,
        mm: minutosFnFinal
      };

      ///----

      this.modalDatosComplementarios = true;
      this.buscarHorariosClinica();
    },
    limpiar(search, atriburo, valor) {
      if (search != null) {
        this.search[search] = "";
      }
      this.filtro[atriburo] = valor;
    },
    limpiarFiltro() {
      this.filtro = {
        idPaciente: null,
        nombrePaciente: null,
        idEstatus: null,
        idsClinica: [],
        fechaInicio: null,
        fechaFin: null,
        idEstatusSolicitud: null
      };
    },
    obtenerDatos(init = true) {

      if (init) {
        this.paginaActual = 1;
      }

      const tipoSolicitud = this.tabIndex + 1;

      this.registros = [];

      this.loader = true;

      this.filtro.idEstatusSolicitud = [tipoSolicitud];

      this.$http
          .post(this.$api + "agendaclinica/listaEspera/obtener?pagina=" + this.paginaActual, this.filtro)
          .then((response) => {
            if (response.status === 200) {
              this.registros = response.data.data.datosBandeja;
              this.totalRegistros = response.data.data.totalRegistros;

              this.semaforo.urgente = this.registros.filter(function (element) {
                return element.idEstatusListaEspera == 1;
              }).length;

              this.semaforo.espera = this.registros.filter(function (element) {
                return element.idEstatusListaEspera == 2;
              }).length;

              this.loader = false;
            }
          })
          .catch((error) => {
            console.error(error);
            this.loader = false
          });
    },
    todos() {
      this.todas = false;
      this.listaClinicas.forEach(element => {
        this.filtro.idsClinica.push(element.idClinica);
      });
    },
    clear() {
      this.todas = true;
      this.filtro.idsClinica = [];
    },
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },
    abrirModalDetalle(item) {
      this.datosDetalle = item;
      this.semaforoDeUrgencia = "color:" + this.datosDetalle.color;
      this.detalle = [
        {
          Clinica: this.datosDetalle.nombreClinica,
          ID_paciente: this.datosDetalle.idPaciente,
          Nombre_paciente: this.datosDetalle.nombrePaciente
          ,
          Correo: this.datosDetalle.correo
          ,
          Telefono: this.datosDetalle.telefono,
          Especialidad: this.datosDetalle.nombreEspecialidad
          ,
          Tratamiento: this.datosDetalle.nombreTratamiento
          ,
          Semaforo_de_urgencia: this.datosDetalle.estatusDescripcion
          ,
          Fecha_alta_en_la_lista_de_espera: this.$moment(this.datosDetalle.fechaAltaEnListaEspera).format('DD-MM-YYYY')
          ,
          Fecha_de_la_cita_requerida: 'De ' + this.$moment(this.datosDetalle.fechaInicioCitaSolicitada).format('DD-MM-YYYY') + ' al ' + this.$moment(this.datosDetalle.fechaFinCitaSolicitada).format('DD-MM-YYYY')
          ,
          Horario: 'Entre ' + this.formatoHora(this.datosDetalle.horaInicioCitaSolicitada) + ' y ' + this.formatoHora(this.datosDetalle.horaFinCitaSolicitada)
          ,
          Motivo_de_envio_a_lista_de_espera: this.datosDetalle.motivoEspera
          ,
          Observaciones: this.datosDetalle.observaciones
        },
      ];
      this.modalDetalleLista = true;
    },
    cerrarModalDetalle() {
      this.modalDetalleLista = false;
    },
    async preBuscarAgenda(item) {
      this.datosDetalle = item;
      this.datosDetalle.horasBusquedaDisp = 1;
      this.datosDetalle.minBusquedaDisp = 0;

      this.showMostrarPreBuscarCita = true;
      this.showAgendarNuevaCita = false;
      this.showAgendarListaEspera = false;
      this.cargandoHorariosDisponibles = false;
    },
    async buscarAgenda() {

      if (this.datosDetalle.horasBusquedaDisp === 0 && this.datosDetalle.minBusquedaDisp === 0){
        this.$swal.fire({
          icon: "alert",
          title: "Aviso",
          text: "Debes seleccionar un rango válido",
        });
        return;
      }

      this.semaforoDeUrgencia = "color:" + this.datosDetalle.color;
      this.detalle = [
        {
          fechaNacimientoCompleta: this.datosDetalle.fechaNacimientoCompleta,
          confianza: this.datosDetalle.confianza,
          idTratamiento: this.datosDetalle.idTratamiento,
          tratamiento: this.datosDetalle.nombreTratamiento,
          idDoctor: this.datosDetalle.idDoctor,
          nombreDoctor: this.datosDetalle.nombreDoctor,
          fechaAltaEnListaEspera: this.datosDetalle.fechaAltaEnListaEspera,
          fechaInicioCitaSolicitada: this.datosDetalle.fechaInicioCitaSolicitada,
          fechaFinCitaSolicitada: this.datosDetalle.fechaFinCitaSolicitada,
          horaInicioCasilla: this.datosDetalle.horaInicioCitaSolicitada,
          horaFinCasilla: this.datosDetalle.horaFinCitaSolicitada,
          idPaciente: this.datosDetalle.idPaciente,
          nombrePaciente: this.datosDetalle.nombrePaciente,
          correo: this.datosDetalle.correo,
          celular: this.datosDetalle.telefono,
          clinica: this.datosDetalle.nombreClinica,
          idTagMotivoCita: this.datosDetalle.idTagMotivoCita,
          motivoCita: this.datosDetalle.motivoCita,
          idEspecialidad: this.datosDetalle.idEspecialidad,
          nombreEspecialidad: this.datosDetalle.nombreEspecialidad,
          idSubtipoPaciente: this.datosDetalle.idSubtipoPaciente,
          subTipoPaciente: this.datosDetalle.subTipoPaciente,
          colorEstatusLista: this.datosDetalle.color,
        }
      ];

      this.lstHorariosDisponibles = null;
      this.showMostrarPreBuscarCita = false;
      this.showAgendarNuevaCita = false;
      this.showAgendarListaEspera = true;
      this.cargandoHorariosDisponibles = true;

      let totalMinutos = this.datosDetalle.minBusquedaDisp;
      if (this.datosDetalle.horasBusquedaDisp > 0) {
        totalMinutos += (60 / this.datosDetalle.horasBusquedaDisp);
      }

      const params = {
        idClinica: this.idClinica,
        idDoctor: [this.datosDetalle.idDoctor],
        fechaInicio: this.$moment(this.datosDetalle.fechaInicioCitaSolicitada).utc().format("YYYY-MM-DD"),
        fechaFin: this.$moment(this.datosDetalle.fechaFinCitaSolicitada).utc().format("YYYY-MM-DD"),
        horaInicio: this.datosDetalle.horaInicioCitaSolicitada,
        horaFin: this.datosDetalle.horaFinCitaSolicitada,
        duracionMinutos: totalMinutos,
        diasSemanaExclusion: this.datosDetalle.diasExclusion
      }

      await this.$http
          .post(
              this.$api +
              "agendaclinica/disponibilidadCitasDoctor", params
          )
          .then((response) => {
            if (response.data.data !== undefined && response.data.data !== null && response.data.data.length > 0) {
              this.lstHorariosDisponibles = response.data.data
            }
          })
          .catch((error) => {
            console.error("Error", error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "No se encontraron horarios disponibles",
            });
          }).finally(() => this.cargandoHorariosDisponibles = false);


    },
    async agendarHorarioDisponible(horario) {
      this.datosFormulario = {
        idListaEspera: this.datosDetalle.idListaEspera,
        idPaciente: this.datosDetalle.idPaciente,
        idDoctor: this.datosDetalle.idDoctor,
        idEspecialidad: this.datosDetalle.idEspecialidad,
        idTagMotivoCita: this.datosDetalle.idTagMotivoCita,
        idTratamiento: this.datosDetalle.idTratamiento,
        sillon: horario.sillon,
        citaAdministrativa: false,
        fechaCita: this.$moment(horario.fechaCita),
        horaInicio: horario.horaInicio,
        horaFin: horario.horaTermina
      };

      this.registrarCitaServ(false);
    },
    async agregarAgendaManual() {

      const trataNuevo =new DatosTratamientoCita();
      trataNuevo.idTratamiento = this.datosDetalle.idTratamiento;

      const horaIniFormateada = this.$formatoHoraIntegerFuncion(this.datosDetalle.horaInicioCitaSolicitada);
      let hInicio = {
        HH: horaIniFormateada.substring(0, 2),
        mm: horaIniFormateada.substring(3, 5)
      };

      this.datosFormulario = {
        idListaEspera: this.datosDetalle.idListaEspera,
        idCita: null,
        idPaciente: this.datosDetalle.idPaciente,
        sillon: this.getListNumeroSillonesClinica[0].value,
        idEspecialidad: this.datosDetalle.idEspecialidad,
        idEmpleado: this.datosDetalle.idDoctor,
        fechaCita: new Date(),
        idTagMotivoCita: this.datosDetalle.idTagMotivoCita,
        horaInicio: hInicio,
        tratamientos: [trataNuevo],
        comentario: null,
        citaAdministrativa: false,

        citaEdicion: true,
      };

      this.showAgendarNuevaCita = true;
    },

    async registrarCitaServ(calcularHoras = true) {

      this.loading = true;
      this.guardando = true;

      const datosGuardar = JSON.parse(JSON.stringify(this.datosFormulario));
      datosGuardar.idClinica = this.idClinica;
      datosGuardar.idCompania = 1;
      datosGuardar.idCanalOrigen = 1;

      var fechaCita = this.$moment(datosGuardar.fechaCita).format("YYYY-MM-DD");
      const horaCita = this.$moment(fechaCita);
      datosGuardar.fechaCita = this.$moment(horaCita)
          .utc()
          .format("YYYY-MM-DD[T]HH:mm[:00Z]");

      if (calcularHoras) {
        datosGuardar.horaInicio = datosGuardar.horaInicio.HH + "" + datosGuardar.horaInicio.mm;
        datosGuardar.horaFin = datosGuardar.horaFin.HH + "" + datosGuardar.horaFin.mm;
      }

      this.$http
          .post(this.$api + "agendaclinica/listaEspera/guardarCita", datosGuardar)
          .then((response) => {
            if (response.status === 200) {
              this.$swal.fire({
                icon: "success",
                title: "La cita se registró con éxito",
              });
              this.guardadoCitaExitoso();
            }
          })
          .catch((error) => {
            console.error(error);
            if (error.response) {
              let mensaje = error.response.data.message;
              try {
                if (error.response.data.data !== undefined) {
                  mensaje +=
                      " (Fecha bloqueo del " +
                      this.$formatoFecha(
                          error.response.data.data.fechaInicioBloqueo
                      ) +
                      " al " +
                      this.$formatoFecha(
                          error.response.data.data.fechaFinBloqueo
                      ) +
                      " de " +
                      this.$formatoHora(
                          error.response.data.data.horaInicioBloqueo
                      ) +
                      " a " +
                      this.$formatoHora(error.response.data.data.horaFinBloqueo) +
                      ")";
                }
              } catch (e) {
                console.error(e);
              }

              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: mensaje,
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Aviso",
                text: "Ocurrio un error al realizar el registro, contacte al administrador e intente nuevamente",
              });
            }
          })
          .finally(() => {
            this.loading = false;
            this.guardando = false;
          });
    },
    calcularNumeroSillones() {
      if (
          this.listaClinicas !== undefined &&
          this.listaClinicas !== null
      ) {
        const clinica = this.listaClinicas.find(
            (c) => c.id === this.idClinica
        );
        if (clinica !== undefined) {
          const sillones = this.listaClinicas.find(
              (c) => c.id === this.idClinica
          ).numeroSillones;
          if (sillones !== undefined && sillones !== null && sillones > 0) {
            return sillones;
          }
        }
      }
      return 1;
    },
    rangoHoraFormEsValidoEditar(item) {
      const val = this.obtenerHorarioClinicaForm;
      if (
          val !== undefined &&
          item.horaInicioCitaSolicitadaN !== undefined && item.horaInicioCitaSolicitadaN !== null &&
          item.horaFinCitaSolicitadaN !== undefined && item.horaFinCitaSolicitadaN !== null
      ) {

        let diaFormato = this.$moment(
            item.fechaCita,
            "DD/MM/YYYY"
        ).format("YYYY/MM/DD");
        if (!diaFormato._isValid) {
          diaFormato = this.$moment(item.fechaCita).format(
              "YYYY/MM/DD"
          );
        }

        const horaInicio = this.$moment(
            diaFormato +
            " " +
            item.horaInicioCitaSolicitadaN.HH +
            ":" +
            item.horaInicioCitaSolicitadaN.mm +
            ":00"
        );
        const horaFin = this.$moment(
            diaFormato +
            " " +
            item.horaFinCitaSolicitadaN.HH +
            ":" +
            item.horaFinCitaSolicitadaN.mm +
            ":00"
        );
        if (horaInicio >= horaFin) {

          return false;
        }

        let esValido = false;
        val.horasMinutosDate.forEach((it) => {
          if (Number(horaInicio.format('HHmm')) >= Number(it.horaInicio.format('HHmm'))
              && Number(horaFin.format('HHmm')) <= Number(it.horaFin.format('HHmm'))) {
            esValido = true;
          }
        });
        return esValido;
      } else {
        this.initDatosCitaNueva();
      }
      return false;
    },
    guardadoCitaExitoso(){
      this.$swal.fire({
        icon: "success",
        title: "La cita se registró con éxito",
      });
      this.showAgendarListaEspera = false;
      this.showAgendarNuevaCita = false;
      this.obtenerDatos();
    }
  },
  computed: {
    formatoHora() {
        return function (horaInicio) {
            if(horaInicio == null){
                return;
            }
            horaInicio = horaInicio.toString();
            if(horaInicio.length > 3){
              return `${horaInicio.substr(0, 2)}:${horaInicio.substr(2, 3)}`;
            }else{
              return `0${horaInicio.substr(0, 1)}:${horaInicio.substr(1, 3)}`;
            }
            
        };
    },

    fechaMinima: function () {
      const now = new Date();
      return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    fechaFinMinima: function () {
      return this.datosComplementarios.fechaInicio;
    },
    rangoHoraForm: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (val !== undefined) {
        return val.horas;
      } else {
        return [];
      }
    },
    obtenerHorarioClinicaForm: function () {
      let sillon = 100;
      let hoy = new Date();
      const pos =
          this.$moment(hoy).format("YYYY/MM/DD") +
          "-" + sillon;
      if (this.horariosClinica[pos] !== undefined) {
        return this.horariosClinica[pos];
      }
      return undefined;
    },
    rangoHoraClinica: function () {
      const val = this.obtenerHorarioClinicaForm;
      if (val !== undefined) {
        return val.original;
      } else {
        return undefined;
      }
    },
    texFechaInicio() {
      return this.filtro.fechaInicio === null || this.filtro.fechaInicio === ""
          ? "Fecha Inicio"
          : this.filtro.fechaInicio;
    },
    texFechaFin() {
      return this.filtro.fechaFin === null || this.filtro.fechaFin === ""
          ? "Fecha Fin"
          : this.filtro.fechaFin;
    },
    getListNumeroSillonesClinica: function () {
      const list = [];
      for (let i=1; i<=this.getNumeroSillonesClinica; i++) {
        list.push({text:i, value:i});
      }
      return list;
    },
    getNumeroSillonesClinica: function () {
      return this.calcularNumeroSillones();
    },
  },
  watch: {
    tipoBusqueda() {
      this.limpiarFiltro();
    },
    tabIndex() {
      this.obtenerDatos();
    },
    paginaActual() {
      this.obtenerDatos(false);
    }
  }
}
</script>

<style scoped>

.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  width: 100%;
  margin-left: 1%;
  margin-right: 9%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::*/
.scroll {
  max-height: 500px;
  overflow-y: auto;
}

.barra {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  margin-right: 80px;
  margin-left: 80px;
  padding: 5px;
  border-radius: 6px;
  text-align: left;
  align-items: center;
}

.row {
  background: transparent !important;
}

.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}

.contenedor-drop {
  overflow: auto;
  max-height: 15em;
}

.btn-clear {
  color: gray;
  position: relative;
  margin-right: 1em;
}

.btn-clear:hover {
  color: black;
  cursor: pointer;
}

.btn-clear:focus {
  color: black;
  box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);
}

.tituloDetalle {
  color: #8ec6e9;
  font-weight: 100;
  padding-left: 10px;
}

label {
  font-weight: bold !important;
}

</style>